import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { CustomerData } from 'types/api/customers.type';

import type { RootState } from '../store';

const customersAdapter = createEntityAdapter({
  selectId: (customer: CustomerData) => customer.id,
});

export const customerSlice = createSlice({
  name: 'customers',
  initialState: customersAdapter.getInitialState(),
  reducers: {
    setCustomers(state, action) {
      customersAdapter.setAll(state, action.payload);
    },
    removeCustomer(state, action) {
      customersAdapter.removeOne(state, action.payload);
    },
  },
});

export const getState = (rootState: RootState) => rootState.customers;

export const customersSelector = customersAdapter.getSelectors(
  (state: RootState) => state.customers
);

export const { setCustomers, removeCustomer } = customerSlice.actions;
